/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonContractCodeListRequest = {
    page?: number;
    size?: number;
    sortField?: BabylonContractCodeListRequest.sortField;
    sortDirection?: BabylonContractCodeListRequest.sortDirection;
};

export namespace BabylonContractCodeListRequest {

    export enum sortField {
        CODE_ID = 'CODE_ID',
        CONTRACT_COUNT = 'CONTRACT_COUNT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

